import {Component, Input, OnInit} from '@angular/core';
import {FaModule} from '../../../../@theme/components/fa/fa.module';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {ThemeModule} from '../../../../@theme/theme.module';
import {Patient} from '../../../../models/patient';
import {ComplexEndDateEntry} from '../../../../models/complex-end-date-entry';

@Component({
    selector: 'app-discharged-patient-entry-indicator',
    standalone: true,
    imports: [
        FaModule,
        NgbTooltipModule,
        ThemeModule,
    ],
    template: `
        @if (!isBst && item?.discharge_date) {
             <far i="clock"
                  class="smart-link smart-link-info mx-0"
                  style="vertical-align: middle; font-size: .75em;"
                  [ngbTooltip]="dischargeWarningTmp">
                 <ng-template #dischargeWarningTmp>
                     <div class="mb-2"><strong>Active order interrupted by patient discharge.</strong></div>
                     <div *ngIf="item.original_end_date">Original end date: <strong>{{ item.original_end_date | simpleDate }}</strong></div>
                     <div *ngIf="!item.original_end_date">Originally <strong>Open-ended</strong></div>
                 </ng-template>
             </far>
        }
  `,
    styles: [':host { display: contents;}'],
})
export class DischargedPatientEntryIndicatorComponent implements OnInit {
    @Input() item: ComplexEndDateEntry;

    isBst: boolean = false;

    ngOnInit() {
        if (!this.item) return;

        const patient = this.item.origin ? this.item : this.item.patient?.origin ? this.item.patient : null;
        this.isBst = patient ? Patient.isBst(patient) : false;
    }
}
